import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedFacility: null,
    selectedSpecialization: null,
    selectedDoctor: null,
    doctorData: null,
    selectedDate: new Date().toISOString(),
    selectedAppointment: {
        time: null,
        date: null,
        duration: null,
        identification: null,
        type: null,
    },
    isOtpVerified: false,
    phone: "",
    uhid: "",
};

const appointmentSlice = createSlice({
    name: 'appointment',
    initialState,
    reducers: {
        updateFacility: (state, action) => {
            state.selectedFacility = action.payload;
        },
        updateSpecialization: (state, action) => {
            state.selectedSpecialization = action.payload;
        },
        updateDoctor: (state, action) => {
            state.selectedDoctor = action.payload;
        },
        updateDoctorData: (state, action) => {
            state.doctorData = action.payload;
        },
        updateDate: (state, action) => {
            state.selectedDate = action.payload;
        },
        updateAppointment: (state, action) => {
            state.selectedAppointment.date = action.payload.date;
            state.selectedAppointment.time = action.payload.time;
            state.selectedAppointment.duration = action.payload.duration;
            state.selectedAppointment.identification = action.payload.identification;
            state.selectedAppointment.type = action.payload.type;
        },
        setInitialState: (state) => {
            state.selectedFacility = null;
            state.selectedSpecialization = null;
            state.selectedDoctor = null;
            state.doctorData = null;
            state.selectedAppointment = {
                time: null,
                date: null,
                duration: null,
                identification: null,
                type: null,
            };
        },
        verifyOtp: (state, action) => {
            state.isOtpVerified = action.payload;
        },
        updatePhone: (state, action) => {
            state.phone = action.payload;
        },
        updateUHID: (state, action) => {
            state.uhid = action.payload;
        }
    },
});

export const { updateDate, updateDoctor, updateFacility, updateSpecialization, setInitialState, updateAppointment, verifyOtp, updatePhone, updateUHID, updateDoctorData } = appointmentSlice.actions;

export default appointmentSlice.reducer;

